import { IPropertyCard } from '@/components/templates/search/interfaces';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS } from '../globalContext/globalContext.interfaces';
import { IThunkApiExtra, RootState } from '../store';

interface State {
	status: STATUS;
	results: IPropertyCard[];
	forIdProperty?: number;
}

export const initialState: State = {
	status: STATUS.init,
	results: [],
}

export const fetchRecommendations = createAsyncThunk<
	{ results: IPropertyCard[]; forIdProperty: number },
	number,
	{ extra: IThunkApiExtra }
>(
	'recommendedProperties/fetch',
	async (idProperty: number, thunkApi) => {
		const { extra, signal } = thunkApi
		const { services } = extra;
		const servicesList = (await services()).setupServices()
		const results = await servicesList.getRecomendaciones(idProperty, signal)
		return { results, forIdProperty: idProperty }
	}
)

export const RecommendedPropertiesSlice = createSlice({
	name: 'recommendedProperties',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchRecommendations.pending, (state) => {
			state.status = STATUS.pending;
		})
		builder.addCase(fetchRecommendations.fulfilled, (state, action) => {
			state.results = action.payload.results;
			state.forIdProperty = action.payload.forIdProperty;
			state.status = STATUS.idle;
		})
		builder.addCase(fetchRecommendations.rejected, (state, action) => {
			if (action.meta.aborted) return; // request cancelado intencionalmente, ignorar
			state.status = STATUS.error;
			state.results = [];
		})
	}
})

export const selectRecommendedProperties = (state: RootState) => state.RecommendedPropertiesState.results;
export const selectRecommendedPropertiesStatus = (state: RootState) => state.RecommendedPropertiesState.status;
